// vendor
import React, { useEffect, useRef } from 'react';
import { useId } from '@reach/auto-id';
import anime from 'animejs';

function Award({ awards, hovered, ...props }) {
  const id = useId();
  const ref = useRef();
  const progress = hovered ? 99.99 : -100;

  // Assigns the shape depending of the awards
  var selectedAward = '';
  if (awards.indexOf('webby') !== -1) {
    selectedAward =
      'M0,0V121l38-10V0ZM12,87.4s7.89.43,7.89,1-7.89.93-7.89.93Zm0,3.35s7.77.22,7.77.77-7.77,1-7.77,1Zm0,2.89s7.68.47,7.68,1.06-7.68.85-7.68.85Zm0,5.18V96.91s7.55,0,7.55.72S12,98.82,12,98.82Zm13.5,6H22.7V101c0-1.28-3.18-1.53-3.18-1.53s2.84-.76,2.84-1.78-3.14-1.45-3.14-1.45,3.14-.59,3.14-1.52-3.61-1.7-3.61-1.7,3.61-.34,3.61-1.28-3.14-1.65-3.14-1.65,3.14-.77,3.14-1.66S19,86.64,19,86.64s3.18,0,3.18-1.28-4.54-1.91-4.54-1.91l-.93,1s3.22.3,3.22.85c0,.85-7.89.72-7.89.72V80H25.5Z';
  } else if (awards.indexOf('lovie') !== -1) {
    selectedAward =
      'M0,0V121l38-10V0ZM9.42,93.67H8V92.24H9.42Zm0-1.75H8V90.5H9.42Zm0-1.74H8V88.76H9.42Zm1.69,5.28H9.69V94h1.42Zm0-1.78H9.69V92.26h1.42Zm0-1.77H9.69V90.48h1.42Zm0-1.78H9.69V88.71h1.42Zm0-1.77H9.69V86.93h1.42Zm1.76,8.86H11.44V95.79h1.43Zm0-1.76H11.44V94h1.43Zm0-1.76H11.44V92.27h1.43Zm0-1.76H11.44V90.52h1.43Zm0-1.76H11.44V88.76h1.43Zm0-3.58H11.44V85.17h1.43Zm1.75,10.62H13.2V95.79h1.42Zm0-1.77H13.2V94h1.42Zm0-1.78H13.2V92.25h1.42Zm0-1.77H13.2V90.48h1.42Zm0-1.77H13.2V88.7h1.42Zm0-1.77H13.2V86.93h1.42Zm0-1.76H13.2V85.17h1.42ZM16.38,99H15V97.55h1.43Zm0-1.77H15V95.78h1.43Zm0-1.77H15V94h1.43Zm0-1.77H15V92.24h1.43Zm0-1.77H15V90.47h1.43Zm0-1.77H15V88.7h1.43Zm0-1.77H15V86.93h1.43Zm0-1.76H15V85.17h1.43Zm1.73,14.16H16.69V99.34h1.42Zm0-1.77H16.69V97.56h1.42Zm0-1.77H16.69V95.79h1.42Zm0-1.78H16.69V94h1.42Zm0-1.77H16.69V92.25h1.42Zm0-1.77H16.69V90.48h1.42Zm0-1.77H16.69V88.7h1.42Zm0-1.77H16.69V86.93h1.42Zm1.76,16H18.45v-1.43h1.42Zm0-1.78H18.45v-1.42h1.42Zm0-1.78H18.45V99.37h1.42Zm0-1.77H18.45V97.59h1.42Zm0-1.78H18.45V95.81h1.42Zm0-1.78H18.45V94h1.42Zm0-1.77H18.45V92.26h1.42Zm0-1.78H18.45V90.48h1.42Zm0-1.78H18.45V88.71h1.42Zm1.77,10.63H20.21V99.34h1.43Zm0-1.77H20.21V97.56h1.43Zm0-1.77H20.21V95.79h1.43Zm0-1.78H20.21V94h1.43Zm0-1.77H20.21V92.25h1.43Zm0-1.77H20.21V90.48h1.43Zm0-1.77H20.21V88.7h1.43Zm0-1.77H20.21V86.93h1.43ZM23.37,99H22V97.55h1.42Zm0-1.77H22V95.78h1.42Zm0-1.77H22V94h1.42Zm0-1.77H22V92.24h1.42Zm0-1.77H22V90.47h1.42Zm0-1.77H22V88.7h1.42Zm0-1.77H22V86.93h1.42Zm0-1.76H22V85.17h1.42Zm1.75,10.62H23.7V95.79h1.42Zm0-1.77H23.7V94h1.42Zm0-1.78H23.7V92.25h1.42Zm0-1.77H23.7V90.48h1.42Zm0-1.77H23.7V88.7h1.42Zm0-1.77H23.7V86.93h1.42Zm0-1.76H23.7V85.17h1.43Zm1.75,10.62H25.46V95.79h1.42Zm0-1.76H25.46V94h1.42Zm0-1.76H25.46V92.27h1.42Zm0-1.76H25.46V90.52h1.42Zm0-1.76H25.46V88.76h1.42Zm0-1.82H25.46V86.93h1.42Zm0-1.76H25.46V85.17h1.42Zm1.76,8.86H27.21V94h1.43Zm0-1.78H27.21V92.26h1.43Zm0-1.77H27.21V90.48h1.43Zm0-1.78H27.21V88.71h1.43Zm0-1.77H27.21V86.93h1.43Zm1.68,5.31H28.9V92.24h1.42Zm0-1.75H28.9V90.5h1.42Zm0-1.74H28.9V88.76h1.42Z';
  } else if (awards.indexOf('awwwards') !== -1) {
    selectedAward =
      'M0,0V121l38-10V0ZM19.68,98.8,18,91.69,16.25,98.8H13.16L9.91,87.46h3.28L14.91,95l1.93-7.57h2.25L21,95l1.7-7.57H26L22.78,98.8Zm7.47.2a1.6,1.6,0,1,1,1.59-1.59A1.62,1.62,0,0,1,27.15,99Z';
  } else if (awards.indexOf('fwa') !== -1) {
    selectedAward =
      'M0,0V121l38-10V0ZM30.34,93.89h-1.4V95.1a.67.67,0,0,1-.66.66H24.21a.66.66,0,0,1-.66-.66V93.23a.65.65,0,0,1,.66-.66h3.41v-.84H23.81l-2.2,3.68a.67.67,0,0,1-.57.32h0a.65.65,0,0,1-.57-.34L19,92.65l-1.68,2.79a.6.6,0,0,1-.26.24.65.65,0,0,1-.89-.28l-1.92-3.67h-3v.77H13.6a.66.66,0,1,1,0,1.32H11.26V95.1a.66.66,0,1,1-1.32,0V93.82H8.58a.66.66,0,0,1,0-1.32H10V91.07a.65.65,0,0,1,.66-.66h4a.65.65,0,0,1,.59.35l1.56,3L18.44,91a.72.72,0,0,1,.25-.24.67.67,0,0,1,.9.26l1.49,2.73,1.8-3a.65.65,0,0,1,.56-.32h4.84a.65.65,0,0,1,.66.66v1.5h1.4a.66.66,0,0,1,0,1.32Z';
  } else if (awards.indexOf('cssda') !== -1) {
    selectedAward =
      'M0,0V121l38-10V0ZM14.91,83.66H21.2L15,89.89l6.22,6.21L18,99.31,8.62,90Zm7.69,18.76H16.31l6.23-6.23L16.33,90l3.2-3.21,9.36,9.36Z';
  }

  useEffect(() => {
    const tween = {
      y: parseInt(ref.current.attributes.y2.value),
    };
    const anim = anime({
      targets: tween,
      easing: 'linear',
      y: progress,
      duration: 250,
      update() {
        ref.current.attributes.y2.value = `${tween.y}%`;
      },
    });
    return () => {
      anim.reset();
    };
  }, [progress]);

  return (
    <svg viewBox="0 0 38 121" {...props}>
      <defs>
        <linearGradient id={`gradient-${id}`} x1="10%" x2="10%" y1="100%" y2="-100%" ref={ref}>
          <stop offset="50%" stopColor="white" stopOpacity="0.45" />
          <stop offset="50%" stopColor="#2fd0b7" stopOpacity="1" />
        </linearGradient>
      </defs>

      <path fill={`url(#gradient-${id})`} d={selectedAward} />
    </svg>
  );
}

export default Award;
